import React, { FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../redux/RootState';
import { UserActions } from '../redux/actions/user';
import { LinkButton } from './styled/LinkButton';
import styled from 'styled-components/macro';
const LogInOutComp: FC<{ className?: string }> = ({ className }) => {
    const userState = useSelector((s: RootState) => s.user);
    const dispatch = useDispatch();
    return (
        <span className={className}>
            {userState.isLoggedOn && <span className="user">{userState.email} </span>}
            <LogInOutButton type="button" onClick={() => dispatch(UserActions.logOnOff(!userState.isLoggedOn))}>
                {userState.isLoggedOn ? <span>Sign out</span> : <span>Sign in</span>}
            </LogInOutButton>
        </span>
    );
};

const LogInOutButton = styled(LinkButton)`
    border: solid 1px ${(props) => props.theme.colors.primary.color};
    padding: 0.5em !important;
    margin-left: 1em;
`;

export const LogInOut = styled(LogInOutComp)`
    white-space: nowrap;
    .user {
        font-weight: 600;
    }
`;
